export enum DeclarationContextTypes {
  Unknow = 0,
  Paused = 2,
  PreFilled = 3,
  ToDo = 4,
}
